"use client";
// Imports

// Icon
export function MapCategoryIcon({ icon, size = 32, active = false }) {
  switch (icon) {
    case "default":
      return <DefaultIcon size={size} active={active} />;

    // Attractions
    case "aggies-farm":
      return (
        <svg
          width="53"
          height="25"
          viewBox="0 0 53 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.9058 10.7349C46.3448 7.9158 51.0372 5.16948 51.3828 6.91548C51.8739 9.33443 43.9441 19.374 28.521 22.484C13.098 25.5941 1.8944 19.3922 1.42153 16.9732C1.05777 15.209 6.47767 15.9365 15.4078 15.2636"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.4078 15.2818C15.3714 16.1912 15.3168 17.0096 15.2805 17.7189C15.2805 17.9917 15.4078 18.2464 15.6442 18.3737C16.7173 18.9193 20.1547 20.156 27.7753 18.6101C35.2868 17.1005 38.0513 14.627 38.8516 13.6995C39.0334 13.4812 39.0698 13.1902 38.9425 12.9356C38.6333 12.299 38.2877 11.5533 37.8876 10.7349C36.8146 8.47963 35.5232 5.69693 34.5411 3.25979C33.9227 1.69566 32.3586 0.913594 30.9945 1.47741C28.6665 2.44135 27.4116 2.91423 24.7016 3.45985C22.0099 4.00548 20.6458 4.04186 18.1359 4.06004C16.6627 4.06004 15.5351 5.40592 15.5533 7.07918C15.6078 9.73457 15.4805 12.7901 15.3714 15.2818"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.738 3.45985C27.4298 2.91423 28.7029 2.42316 31.0309 1.47741C32.395 0.913594 33.9409 1.69566 34.5775 3.25979C35.9234 6.58812 37.8149 10.5348 38.9789 12.9356C39.1062 13.1902 39.0698 13.4812 38.8879 13.6995C38.0877 14.627 35.3232 17.1005 27.8117 18.6101C20.1911 20.1379 16.7537 18.9193 15.6806 18.3737C15.4442 18.2464 15.2986 17.9917 15.3168 17.7189C15.4623 15.0453 15.6806 10.6803 15.626 7.07918C15.6078 5.38774 16.7355 4.06004 18.2087 4.06004C20.7185 4.06004 22.0826 4.00548 24.7744 3.45985"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );

    // case "animal":
    //   return null;

    // case "attractions":
    //   return null;

    // case "bar":
    //   return null;

    // case "carnival":
    //   return null;

    // case "celler-door":
    //   return null;

    // case "competition":
    //   return null;

    // case "dining":
    //   return null;

    // case "education":
    //   return null;

    // case "kids-carnival":
    //   return null;

    // case "lifestyle":
    //   return null;

    // case "live-entertainment":
    //   return null;

    // case "shopping":
    //   return null;

    // Facilities
    default:
      return null;
  }
}

function DefaultIcon({ size, active }) {
  return (
    <svg
      width="36"
      height="57"
      viewBox="0 0 36 57"
      fill="none"
      className="w-40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2693 0.307678C8.63424 0.307678 0.820557 8.12136 0.820557 17.7564C0.820557 32.8799 18.2693 56.7034 18.2693 56.7034C18.2693 56.7034 35.718 32.8799 35.718 17.7564C35.7241 8.12136 27.9104 0.307678 18.2693 0.307678Z"
        className={`${active ? "text-brand-orange" : "text-grey"} fill-current`}
      />
      <path
        d="M28.0325 28.118C33.4245 22.7259 33.4245 13.9837 28.0325 8.59161C22.6404 3.19956 13.8982 3.19956 8.5061 8.59161C3.11405 13.9837 3.11405 22.7259 8.5061 28.118C13.8982 33.51 22.6404 33.51 28.0325 28.118Z"
        className="text-white fill-current"
      />
    </svg>
  );
}
